<template>
  <div class="home">
    <!-- home block -->
    <categories-navigation />
  </div>
</template>

<script>
import { toast } from 'theme/modules/notifications'

export default {
  name: 'home',
  head () {
    const title = this.$store.state.cms.meta.title
    const description = this.$store.state.cms.meta.description
    const keywords = this.$store.state.cms.meta.keywords
    return {
      title: title,
      meta: [{
        vmid: 'description',
        name: 'description',
        content: description
      },
      {
        vmid: 'keywords',
        name: 'keywords',
        content: keywords
      }]
    }
  },
  beforeMount () {
    if (process.client) {
      return this.$store.commit('ui/setHeaderPageTitle', 'catalog')
    }
  },
  mounted () {
    if (process.client) {
      // manage error
      $('body').removeClass('scroll-up scroll-down')
      this.$route.query.msg_error && toast.error(this.$route.query.msg_error)
    }
  },
  components: {
    CategoriesNavigation: () => import('theme/components/Categories/CategoriesNavigation')
  }
}
</script>
